<!-- Sidebar -->
<p-drawer [visible]="viewClass()" [showCloseIcon]="false" position="right" [blockScroll]="true" [dismissible]="false"
  styleClass="client-profile-sidebar p-0 w-full" (onHide)="ClosePopup()" appendTo="body" [autoZIndex]="true"
  aria-label="view-class-sidebar">
  <ng-template #headless>
    <!-- Header -->
    <div
      class="surface-0 border-bottom-1 border-300 sticky left-0 top-0 w-full z-2 flex align-items-center justify-content-between">
      <div class="flex align-items-center flex-1">
        <!-- Close Icon -->
        <div class="h-3rem w-3rem cursor-pointer surface-200 flex align-items-center justify-content-center"
          (click)="ClosePopup()" data-testid="close-view-class">
          <i class="fa fa-times text-xl text-600"></i>
        </div>
        <!-- Close Icon -->

        <h4 class="mb-0 text-sm p-3 text-green-500 flex-1" aria-label="class-type">
          {{ classData().type_name_primary_language || classData().type_name_secondary_language}}
        </h4>
      </div>

      <!-- Left Side Toggle -->
      <div
        class="md:hidden flex align-items-center gap-2 cursor-pointer px-3 py-2 hover:surface-100 border-round transition-colors transition-duration-150"
        (click)="showLeftView = !showLeftView" data-testid="toggle-left-view">
        <span class="text-xs font-medium text-700 white-space-nowrap">
          {{ showLeftView ? 'Hide' : 'Show' }} Details
        </span>
        <i class="fa text-lg text-primary transition-all transition-duration-300"
          [ngClass]="showLeftView ? 'fa-angle-up' : 'fa-angle-down'"></i>
      </div>
      <!-- Left Side Toggle -->
    </div>
    <!-- Header -->

    @if (
    classData()!.status.toLowerCase() === ClassStatus.Cancelled.toLowerCase()
    ) {
    <div class="px-3 py-2 md:px-0 md:py-0">
      <p-message severity="error" icon="fa fa-exclamation-triangle" styleClass="text-sm"
        aria-label="cancelled-warning-icon" data-testid="cancelled-warning-icon">
        <div class="flex align-items-start w-full">
          <i class="fa fa-exclamation-triangle text-xl flex-shrink-0 mr-2" aria-label="cancelled-warning-icon"></i>
          <div class="line-height-3 text-xs md:text-sm">
            <strong class="block mb-1" aria-label="cancelled-message">{{
              'SCHEDULE.VIEWCLASS.CLASS_CANCELLED' | translate
              }}</strong>
            @if (classObj) {
            <span class="block" aria-label="cancellation-reason">{{
              classObj!.cancellation_reason
              }}</span>
            }
          </div>
        </div>
      </p-message>
    </div>
    }

    <!-- Content Wrapper -->
    <div class="relative" style="height: calc(100vh - 3rem)">
      <div class="xl:flex bg-green-50 h-full">
        <!-- Left Side -->
        <div [ngClass]="showLeftView ? 'block' : 'hidden'"
          class="xl:block xl:w-6 px-3 py-1 border-right-1 border-300 overflow-y-auto h-full pb-32 xl:pb-8"
          style="max-height: 100%">
          <!-- Warning Message - Only for non-completed, non-cancelled classes -->
          @if (
          classData()!.status.toLowerCase() !==
          ClassStatus.Cancelled.toLowerCase() &&
          classData()!.status.toLowerCase() !== 'completed' &&
          classData()!.status.toLowerCase() !== 'closed'
          ) {
          <div class="my-3">
            <p-message severity="warn" icon="fa fa-exclamation-triangle" styleClass="text-xs"
              aria-label="attendance-warning" data-testid="attendance-warning">
              <div class="line-height-3 text-xs">
                {{ 'SCHEDULE.VIEWCLASS.CLASS_COMPLETED_WARNING' | translate }}
              </div>
            </p-message>
          </div>
          }

          <form [formGroup]="classViewForm" aria-label="class-view-form">
            <!-- Form Group -->
            <div class="my-3">
              <p-select [options]="getClassActions" formControlName="selectedAction" optionLabel="name" filterBy="name"
                styleClass="w-full text-sm shadow-2 border-2 border-primary" placeholder="{{'SCHEDULE.VIEWCLASS.CLASS_ACTION' | translate}}" 
                (onChange)="selectAction($event)" dropdownIcon="fa fa-chevron-down text-primary"
                aria-label="class-action-dropdown">
                <ng-template pTemplate="selectedItem">
                  @if (selectedClassAction) {
                  <div class="text-sm flex align-items-center">
                    <i class="{{ selectedClassAction.icon }} text-600 mr-2" aria-label="action-icon"></i>
                    <span>{{'SCHEDULE.VIEWCLASS.ACTION.' + selectedClassAction.key | translate }}</span>
                  </div>
                  }
                </ng-template>
                <ng-template let-classAction pTemplate="item">
                  <div class="text-sm flex align-items-center">
                    <i class="{{ classAction.icon }} text-600 mr-2" aria-label="action-icon"></i>
                    <span>{{
                      'SCHEDULE.VIEWCLASS.ACTION.' + classAction.key | translate
                      }}</span>
                  </div>
                </ng-template>
              </p-select>
            </div>
            <!-- Form Group -->

            <!-- Form Group -->
            <div class="mb-2" 
            [ngClass]="isClassCompletedOrCancelled ? 'opacity-40 pointer-events-none' : ''">
              <label [for]="'calendar-12h'" class="font-medium text-700 text-xs mb-2 block uppercase"
                aria-label="datetime-label">{{ 'SCHEDULE.VIEWCLASS.LBL_DATETIME' | translate }}</label>
              <p-datepicker inputId="calendar-12h" formControlName="startDate" [showTime]="true"
                styleClass="text-sm w-full" inputstyleClass="text-sm m-0 border-400 h-2rem border-round"
                [placeholder]="'SCHEDULE.VIEWCLASS.SELECTDATE' | translate" [hourFormat]="12"
                (onClose)="OnScheduleDateSelect($event)" aria-label="datetime-calendar" />
            </div>
            <!-- Form Group -->

            <!-- Form Group -->
            @if (classObj && classObj.is_recuring) {
            <div class="w-full mb-3" [ngClass]="
                  isClassCompletedOrCancelled
                    ? 'opacity-40 pointer-events-none'
                    : ''
                ">
              <!-- Input Field -->
              @if (!RRuleObject.RRule) {
              <div class="p-input-icon-right w-full text-sm" (click)="showRRule = true" data-testid="repeat-input">
                <div class="p-inputtext p-component p-element cursor-pointer bg-blue-50 w-full">
                  {{ 'SCHEDULE.VIEWCLASS.REPEAT' | translate }}
                </div>
              </div>
              }
              @if (RRuleObject.RRule) {
              <div class="p-input-icon-right w-full text-sm cursor-pointer" data-testid="repeat-selected">
                <div class="flex align-items-center">
                  <i class="fa fa-times text-base text-600 mr-2 cursor-pointer" (click)="
                          showRRule = false;
                          RRuleObject.RRule = undefined;
                          RRuleObject.RRuleText = undefined
                        " data-testid="clear-repeat"></i>
                  <div class="p-inputtext p-component p-element w-full" (click)="showRRule = true">
                    {{ RRuleObject.RRuleText }}
                  </div>
                </div>
              </div>
              }
              <!-- Input Field -->
            </div>
            }
            <!-- Form Group -->

            <!-- Form Group -->
            <div class="mb-3">
              <label [for]="'trainer-selector'" class="font-medium text-700 text-xs mb-2 block uppercase"
                aria-label="trainer-label">{{
                'SCHEDULE.CREATEAPPOINTMENT.LBL_TRAINER'
                | translate
                | uppercase
                }}</label>
              <staff-selector [formGroup]="classViewForm" [controlName]="SelectedTrainerFormControl"
                [id]="selectedTrainerId" [claims]="claims" [styleClass]="'w-full text-sm'"
                [placeHolder]="'SCHEDULE.CREATEAPPOINTMENT.SELECT' | translate"
                (selectedStaff)="getSelectedStaff($event)" [filterstaff]="filterStaffIds"
                aria-label="trainer-selector" />
            </div>
            <!-- Form Group -->

            <!-- Form Group -->
            <div class="mb-3">
              <label [for]="'location-search'" class="font-medium text-700 text-xs mb-2 block uppercase"
                aria-label="location-label">{{
                'SCHEDULE.VIEWCLASS.LBL_LOCATION' | translate | uppercase
                }}</label>
              @if (!duplicateClass) {
              <ff-google-places [competitorName]="PlaceNameControl" [placeId]="classData().place_id" [placeHolderName]="
                    'SCHEDULE.VIEWCLASS.SEARCH_LOCATION' | translate
                  " (fetchPlaceInfo)="getPlaceDetails($event)" aria-label="location-search" />
              }
            </div>
            <!-- Form Group -->

            <!-- Form Group -->
            @if (isVirtal) {
            <div class="mb-3">
              <label [for]="'virtual-url-input'" class="font-medium text-700 text-xs mb-2 block uppercase"
                aria-label="virtual-url-label">{{ 'SCHEDULE.VIEWCLASS.LBL_VIRTUALURL' | translate }}</label>
              <input type="url" class="text-sm w-full" pInputText formControlName="virtualUrl" #keyUpInputDelay
                placeholder="{{
                    'SCHEDULE.VIEWCLASS.VIRTUALURL' | translate
                  }}" (keyup)="onKeyUpDelay(keyUpInputDelay.value)" aria-label="virtual-url-input" />
              @if (
              VirtualUrlFormControl.touched && VirtualUrlFormControl.invalid
              ) {
              <app-error-msg [errors]="VirtualUrlFormControl.errors" [fieldLabel]="
                      'SCHEDULE.CREATEAPPOINTMENT.LBL_VIRTUALURL' | translate
                    " />
              }
            </div>
            }
            <!-- Form Group -->

            <!-- Form Group -->
            @if (!isVirtal) {
            <div class="mb-3">
              <label [for]="'room-selector'" class="font-medium text-700 text-xs mb-2 block uppercase"
                aria-label="room-label">{{ 'SCHEDULE.VIEWCLASS.LBL_ROOM' | translate }}</label>
              <select-room [formGroup]="classViewForm" [controlName]="SelectedRoomFormControl" [tenantId]="tenantId()"
                [styleClass]="'text-sm w-full'" [roomId]="selectedRoomId" (selectedRoom)="getSelectedRoomEvent($event)"
                aria-label="room-selector" />
            </div>
            }
            <!-- Form Group -->

            <!-- Form Group -->
            <div class="mb-3">
              <label [for]="'comments-textarea'" class="font-medium text-700 text-xs mb-2 block uppercase"
                aria-label="comments-label">{{
                'SCHEDULE.CREATEAPPOINTMENT.COMMENT' | translate | uppercase
                }}</label>
              <textarea pInputTextarea class="w-full text-sm h-3rem" formControlName="comments" #CommentskeyUpInputDelay
                placeholder="{{
                  'SCHEDULE.CREATECLASS.ADDCOMMENTS' | translate
                }}" (keyup)="onCommentsKeyUpDelay(CommentskeyUpInputDelay.value)" aria-label="comments-textarea">
              </textarea>
            </div>
            <!-- Form Group -->

            <!-- Form Group -->
            <div class="mb-2">
              <div class="flex align-items-center">
                <p-toggleSwitch formControlName="accepts_trial" (onChange)="onAcceptTrialChange($event)"
                  aria-label="accept-trial-switch" />
                <p class="text-sm mb-0 ml-3 -mt-1">
                  {{ 'SCHEDULE.CREATECLASS.ACCEPT_TRIALS' | translate }}
                </p>
              </div>
            </div>
            <!-- Form Group -->

            <!-- Row -->
            <div class="md:flex flex-wrap justify-content-between relative border-top-1 border-300">
              <div class="my-3 md:w-5 md:pr-3">
                <label [for]="'subpurpose-value'" class="font-medium text-700 text-xs mb-2 block uppercase"
                  aria-label="subpurpose-label">{{
                  'SCHEDULE.VIEWAPPOINTMENT.SUBPURPOSE' | translate
                  }}</label>
                <strong class="block" aria-label="subpurpose-value">{{
                  classData().subtype_name_primary_language ||
                  classData().subtype_name_secondary_language
                  }}</strong>
              </div>

              <!-- Form Group -->
              <div class="my-3 md:w-7">
                <label [for]="'class-type-value'" class="font-medium text-700 text-xs mb-2 block uppercase"
                  aria-label="class-type-label">{{ 'SCHEDULE.VIEWCLASS.CLASS_TYPE' | translate }}</label>
                <strong class="block"><i class="mr-2 text-600" [ngClass]="selectedBehaviourType!.icon"
                    aria-label="class-type-icon"></i>
                  {{ selectedBehaviourType!.name }}
                </strong>
              </div>
              <!-- Form Group -->
            </div>
            <!-- Row -->

            <!-- Row -->
            <div class="md:flex flex-wrap justify-content-between relative border-top-1 border-300">
              <!-- Form Group -->
              <div class="md:mb-0 my-3 pr-3 w-6 md:w-5" [ngClass]="
                  isClassCompletedOrCancelled
                    ? 'opacity-40 pointer-events-none'
                    : ''
                ">
                <label [for]="'reservation-limit-input'"
                  class="font-medium text-700 text-xs mb-0 block uppercase white-space-nowrap"
                  aria-label="reservation-limit-label">{{
                  'SCHEDULE.VIEWCLASS.RESERVATION_LIMIT' | translate
                  }}</label>
                @if (!reservationLimitEdit) {
                <strong (click)="reservationLimitEdit = true"
                  class="block cursor-pointer border-round hover:surface-200 p-2 md:w-6rem"
                  data-testid="edit-reservation-limit">{{ GetMaxCapacityFormValue | number }}
                </strong>
                }

                @if (reservationLimitEdit) {
                <div class="p-inputgroup md:w-6rem">
                  <app-input-number [formGroup]="classViewForm" [controlName]="classViewForm.get('maxCapacity')"
                    [styleClass]="'w-full text-sm'" [conditionToFormat]="false" [mode]="'number'"
                    aria-label="reservation-limit-input" />
                  <button type="button" pButton pRipple icon="fa fa-times text-xl"
                    class="p-button-secondary border-top-none border-left-none border-bottom-none border-right-1 border-white"
                    (click)="EditMaxCapacity(false)" aria-label="cancel-reservation-limit-button"></button>
                  <button type="button" pButton pRipple icon="fa fa-check" class="p-button-secondary" (click)="reservationLimitEdit = false; EditMaxCapacity(true)" aria-label="save-reservation-limit-button"></button>
                </div>
                }
              </div>
              <!-- Form Group -->

              <!-- Form Group -->
              <div class="md:mb-0 my-3 md:pr-3 w-6 md:w-3" [ngClass]="
                  isClassCompletedOrCancelled
                    ? 'opacity-40 pointer-events-none'
                    : ''
                ">
                <label [for]="'waitlist-input'" class="font-medium text-700 text-xs mb-2 block uppercase"
                  aria-label="waitlist-label">{{ 'SCHEDULE.VIEWCLASS.WAIT_LIST' | translate }}</label>
                @if (!waitListEdit) {
                <strong (click)="waitListEdit = true" data-testid="edit-waitlist">
                  {{ GetMaxWaitListFormValue | number }}
                </strong>
                }

                @if (waitListEdit) {
                <div class="p-inputgroup md:w-5rem relative z-2">
                  <app-input-number [formGroup]="classViewForm" [controlName]="classViewForm.get('maxWaitlist')"
                    [styleClass]="'w-full text-sm'" [conditionToFormat]="false" [mode]="'number'"
                    aria-label="waitlist-input" />
                  <button type="button" pButton pRipple icon="fa fa-times text-xl"
                    class="p-button-secondary border-top-none border-left-none border-bottom-none border-right-1 border-white"
                    (click)="EditMaxWaitlist(false)" aria-label="cancel-waitlist-button"></button>
                  <button type="button" pButton pRipple icon="fa fa-check" class="p-button-secondary"
                    (click)="EditMaxWaitlist(true)" aria-label="save-waitlist-button"></button>
                </div>
                }
              </div>
              <!-- Form Group -->

              <!-- Form Group -->
              <div class="md:pr-3 my-3 w-12 md:w-4">
                <label [for]="'drop-in-dropdown'" class="font-medium text-700 text-xs mb-2 block uppercase"
                  aria-label="drop-in-label">{{ 'SCHEDULE.VIEWCLASS.DROP_IN' | translate }}</label>
                <p-select [options]="dropIns" formControlName="isDropInAllowed" optionLabel="name" filterBy="name"
                  styleClass="md:w-full align-items-center text-sm border-none bg-green-50  p-0 -mt-2 md:w-7rem"
                  (onChange)="onDropInChange($event)" aria-label="drop-in-dropdown">
                  <ng-template pTemplate="selectedItem">
                    @if (selectedDropin) {
                    <div class="text-sm font-bold">
                      {{ selectedDropin.name }}
                    </div>
                    }
                  </ng-template>
                  <ng-template let-dropIn pTemplate="item">
                    <div class="text-sm">{{ dropIn.name }}</div>
                  </ng-template>
                </p-select>
              </div>
              <!-- Form Group -->
            </div>
            <!-- Row -->

            @if (classObj) {
            <div
              class="flex flex-wrap gap-2 px-0 py-3 border-top-1 border-300 text-xs"
              aria-label="class-booking-window-status"
            >
              <div
                class="flex align-items-center gap-2 surface-100 border-round px-2 py-1"
                aria-label="class-early-cancel-status"
              >
                <span class="text-600 font-medium uppercase">{{
                  'SCHEDULE.VIEWCLASS.EARLY_CANCEL_WINDOW' | translate
                }}</span>
                <p-tag
                  [severity]="earlyCancelWindowOpen ? 'success' : 'secondary'"
                  styleClass="text-xxs"
                  [value]="earlyCancelWindowStatusKey | translate"
                />
              </div>
              <div
                class="flex align-items-center gap-2 surface-100 border-round px-2 py-1"
                aria-label="class-waitlist-roster-status"
              >
                <span class="text-600 font-medium uppercase">{{
                  'SCHEDULE.VIEWCLASS.WAITLIST_ROSTER' | translate
                }}</span>
                <p-tag
                  [severity]="waitlistRosterOpen ? 'success' : 'secondary'"
                  styleClass="text-xxs"
                  [value]="waitlistRosterStatusKey | translate"
                />
              </div>
              <div
                class="flex align-items-center gap-2 surface-100 border-round px-2 py-1 w-full md:w-auto"
                aria-label="class-b2c-booking-status"
              >
                <span class="text-600 font-medium uppercase">{{
                  'SCHEDULE.VIEWCLASS.B2C_BOOKING_STATUS' | translate
                }}</span>
                <p-tag severity="warn" styleClass="text-xxs" [value]="b2cBookingStatusKey | translate" />
              </div>
            </div>
            }
          </form>
        </div>
        <!-- Left Side -->

        <!-- Right Side -->
        <div [ngClass]="showLeftView ? 'hidden' : 'flex'"
          class="xl:flex xl:w-12 surface-0 relative flex-column justify-content-between pt-2 h-full overflow-hidden"
          style="max-height: 100%">
          @if (showClientDetails | async) {
          <class-client-booking
            class="p-sidebar-content__wrapper flex flex-column justify-content-between w-full h-full overflow-hidden"
            [classData]="classObj" [tenantId]="tenantId()" (CloseViewClass)="CloseViewClass($event)"
            (UpdateClassData)="UpdateClassData($event)" [showLeftView]="showLeftView"
            aria-label="client-booking-section" />
          }
        </div>
        <!-- Right Side -->
      </div>
    </div>
    <!-- Content Wrapper -->
  </ng-template>
</p-drawer>

<!-- Sidebar -->

<!-- Cancel Class Modal -->
<p-dialog [visible]="cancelClassPopup" (onHide)="cancelClassPopup = false" [resizable]="false" appendTo="body"
  [modal]="true" [breakpoints]="{ '767px': '100vw' }" [style]="{ width: '470px' }" styleClass="no-header-modal"
  aria-label="cancel-class-dialog">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="deleteClassForm" aria-label="cancel-class-form">
      <!-- Content -->
      <div class="relative text-center px-4 py-5">
        <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="cancelClassPopup = false" data-testid="close-cancel-class-dialog"></div>

        <i class="fa fa-exclamation-triangle p-error text-7xl mt-5" aria-label="warning-icon"></i>

        <h4 class="text-base md:text-lg mb-2 mt-5 mb-0 font-bold" aria-label="cancel-confirmation-title">
          {{ 'SCHEDULE.VIEWCLASS.CANCEL_CONFIM' | translate }} <br />
          {{ eventData()!.title }} {{ 'SCHEDULE.VIEWCLASS.FOR' | translate }}
          {{ classData().start_datetime | datetimeformat: 'mediumDate' }} ?
        </h4>
      </div>

      <div class="px-4 pt-4 pb-3 border-top-1 border-300">
        <h4 class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="cancel-reason-label">
          {{ 'SCHEDULE.VIEWCLASS.CANCEL_REASON' | translate }}
        </h4>
        <textarea pInputTextarea class="w-full text-sm h-7rem mb-3" formControlName="cancellation_reason" placeholder="{{
            'SCHEDULE.VIEWCLASS.REASON_PLACEHOLDER' | translate
          }}" aria-label="cancel-reason-input"></textarea>
      </div>

      <!-- Modal Footer -->
      <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
        <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-secondary p-button-text text-sm" (click)="cancelClassPopup = false"
          aria-label="cancel-class-button"></button>
        <button pButton pRipple type="button" [label]="'SCHEDULE.VIEWCLASS.CONTINUE' | translate"
          class="p-button-danger text-sm" (click)="CancelClass(deleteClassForm)"
          aria-label="confirm-cancel-class-button"></button>
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Cancel Class Modal -->

<!-- Delete Class Modal -->
<p-dialog [visible]="deleteClassPopup" (onHide)="deleteClassPopup = false" [resizable]="false" appendTo="body"
  [modal]="true" [breakpoints]="{ '767px': '100vw' }" [style]="{ width: '470px' }" styleClass="no-header-modal"
  aria-label="delete-class-dialog">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <div class="relative text-center px-4 py-5">
      <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
        (click)="deleteClassPopup = false" data-testid="close-delete-class-dialog"></div>
      <i class="fa fa-exclamation-triangle p-error text-7xl mt-5" aria-label="warning-icon"></i>
      <h4 class="text-base md:text-lg mb-2 my-5 font-bold" aria-label="delete-confirmation-title">
        {{ 'SCHEDULE.VIEWCLASS.DELETE_CONFIM' | translate }} <br />
        {{ eventData()!.title }} {{ 'SCHEDULE.VIEWCLASS.FOR' | translate }}
        {{ classData().start_datetime | datetimeformat: 'mediumDate' }} ?
      </h4>
    </div>
    <!-- Content -->

    <!-- Modal Footer -->
    <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
      <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
        class="p-button-secondary p-button-text text-sm" (click)="deleteClassPopup = false"
        aria-label="cancel-delete-class-button"></button>
      <button pButton pRipple type="button" [label]="'SCHEDULE.VIEWCLASS.CONTINUE' | translate"
        class="p-button-danger text-sm" (click)="DeleteClass()" aria-label="confirm-delete-class-button"></button>
    </div>
    <!-- Modal Footer -->
  </ng-template>
</p-dialog>
<!-- Delete Class Modal -->

<!-- Delete Class Modal -->
<p-dialog [visible]="showAddClientConfirmPopup" (onHide)="showAddClientConfirmPopup = false" [resizable]="false"
  appendTo="body" [modal]="true" [breakpoints]="{ '767px': '100vw' }" [style]="{ width: '470px' }"
  styleClass="no-header-modal" aria-label="add-client-confirm-dialog">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <div class="relative text-center px-4 py-5">
      <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
        (click)="showAddClientConfirmPopup = false" data-testid="close-add-client-dialog"></div>
      <i class="fa fa-exclamation-triangle p-error text-7xl mt-5" aria-label="warning-icon"></i>
      <h4 class="text-base md:text-lg mb-2 my-5 font-bold" aria-label="confirm-message">
        {{ 'SCHEDULE.VIEWCLASS.MSG.CONFIRM_WAITLIST_MSG' | translate }}
      </h4>
    </div>
    <!-- Content -->

    <!-- Modal Footer -->
    <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
      <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
        class="p-button-secondary p-button-text text-sm" (click)="showAddClientConfirmPopup = false"
        aria-label="cancel-add-client-button"></button>
      <button pButton pRipple type="button" [label]="'SCHEDULE.VIEWCLASS.CONTINUE' | translate"
        class="p-button-danger text-sm" (click)="AddClientToWaitlist()" aria-label="confirm-add-client-button"></button>
    </div>
    <!-- Modal Footer -->
  </ng-template>
</p-dialog>
<!-- Delete Class Modal -->

<!-- Show Recurring Event Modal -->
<p-dialog [visible]="showRecurringEventUpdatePopup" [resizable]="false" appendTo="body"
  [modal]="true" [breakpoints]="{ '767px': '100vw' }" [style]="{ width: '350px' }" styleClass="" [blockScroll]="true"
  [closable]="false" aria-label="recurring-event-dialog">
  <ng-template pTemplate="header" styleClass="hidden">{{ 'SCHEDULE.VIEWAPPOINTMENT.EDIT_RECURRING_EVENT' | translate }}
  </ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="updateEventForm" aria-label="update-event-form">
      <ul class="list-none p-0 m-0 text-sm">
        <li class="my-3 flex align-items-start">
          <p-radioButton name="updateEvent" value="thisevent" inputId="option1" formControlName="updateEvent"
            aria-label="this-event-option" />
          <label class="ml-2" for="option1">{{
            'SCHEDULE.VIEWAPPOINTMENT.THIS_EVENT' | translate
            }}</label>
        </li>
        <li class="my-3 flex align-items-start">
          <p-radioButton name="updateEvent" value="thisandfollowingevents" inputId="option2"
            formControlName="updateEvent" aria-label="this-and-following-option" />
          <label class="ml-2" for="option2">{{
            'SCHEDULE.VIEWAPPOINTMENT.THIS_AND_FOLLOWING' | translate
            }}</label>
        </li>
      </ul>
    </form>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
      class="p-button-secondary p-button-text text-sm" (click)="UpdateEvent(false)"
      aria-label="cancel-update-event-button"></button>

    <button pButton pRipple type="button" [label]="'common.BUTTONS.BUTTON-TEXT-OK' | translate" class="text-sm"
      (click)="UpdateEvent(true, $event)" [loading]="btnLoading" aria-label="confirm-update-event-button"></button>
    <p-confirmpopup key="bookconfirm" />
  </ng-template>
</p-dialog>
<!-- Show Recurring Event Modal -->

@if (duplicateClass) {
<duplicate-class [visible]="duplicateClass" [classData]="classObj" [tenantId]="tenantId()"
  (CloseDuplicateClass)="CloseDuplicateClassSidebar($event)" />
}

<app-rrule [visible]="showRRule" (onHide)="HideRRule({})" [showNeverStop]="true" [minimumDate]="minimumDate"
  [rRuleObj]="RRuleObject" (hideRrule)="HideRRule($event)" (emitRRule)="FetchRRuleData($event)" />